import {
  DSA_REVIEW_CHECK,
  DSA_REVIEW_DISMISS,
  DSA_REVIEWED_SET,
  DSA_MISSING_INFO_SHOW,
  DSA_MISSING_INFO_DISMISS,
} from "./DSAReviewTypes";

const DSA_REVIEW_DISMISSED_KEY = "dsaReviewDismissed";

export const checkDsaReviewStatus = (cognitoSelfResult) => {
  return (dispatch) => {
    const dsaReviewed = cognitoSelfResult?.dsaReviewed;
    const alreadyDismissed =
      sessionStorage.getItem(DSA_REVIEW_DISMISSED_KEY) === "true";
    dispatch({ type: DSA_REVIEWED_SET, payload: dsaReviewed ?? null });
    dispatch({
      type: DSA_REVIEW_CHECK,
      payload: dsaReviewed === false && !alreadyDismissed,
    });
  };
};

export const dismissDsaReviewPopup = () => {
  sessionStorage.setItem(DSA_REVIEW_DISMISSED_KEY, "true");
  return {
    type: DSA_REVIEW_DISMISS,
  };
};

export const checkDsaMissingInfo = (isDraft, hasEuCountries) => {
  return (dispatch, getState) => {
    const { dsaReviewed } = getState().dsaReview;
    dispatch({
      type: DSA_MISSING_INFO_SHOW,
      payload: isDraft && hasEuCountries && dsaReviewed === false,
    });
  };
};

export const dismissDsaMissingInfoPopup = () => ({
  type: DSA_MISSING_INFO_DISMISS,
});

export const triggerDsaMissingInfoPopup = () => ({
  type: DSA_MISSING_INFO_SHOW,
  payload: true,
});